import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isExternalRole } from "../rbac";

export const useExternalUserRedirect = () => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.user);

  useEffect(() => {
    if (!userDetails?.role) return;

    if (userDetails.customerSettings?.ne1Wms === 0 && isExternalRole(userDetails.role)) {
      navigate("/learnMore");
    }
  }, [userDetails, navigate]);
};
